// extracted by mini-css-extract-plugin
export var addViewLink = "_i-1";
export var availabilityIcon = "_i-16";
export var availabilitySelectionIcon = "_i-15";
export var backButton = "_i-2";
export var backIcon = "_i-z";
export var conversationCount = "_i-3";
export var dragHandle = "_i-5";
export var dropdown = "_i-e";
export var dropdownIcon = "_i-7";
export var dropdownOption = "_i-6";
export var dropdownTriangle = "_i-d";
export var expand = "_i-f";
export var folder = "_i-i";
export var folderItem = "_i-c";
export var icon = "_i-8";
export var iconRow = "_i-9";
export var image = "_i-a";
export var logo = "_i-b";
export var navContainer = "_i-h";
export var navigationFooter = "_i-g";
export var pageShell = "_i-0";
export var placeholderAvailable = "_i-11";
export var placeholderBox = "_i-14";
export var placeholderBusy = "_i-13";
export var placeholderUnavailable = "_i-12";
export var profile = "_i-k";
export var profileContainer = "_i-m";
export var profileDropdown = "_i-n";
export var profileImage = "_i-l";
export var profileMain = "_i-o";
export var profileSubtitle = "_i-q";
export var profileTitle = "_i-p";
export var reorderIcon = "_i-r";
export var sentLine = "_i-u";
export var settingsHeader = "_i-s";
export var sidenavTextColor = "_i-y";
export var spamLine = "_i-t";
export var subitemWithTag = "_i-4";
export var supportItems = "_i-j";
export var teamText = "_i-10";
export var viewLine = "_i-x";
export var viewLineButton = "_i-w";
export var viewLineButtons = "_i-v";